<template>
    <div id="regBylink-container">
        <v-row class="px-2">
            <v-col lg="6" md="6" sm="12" xs="12" offset-lg="3" offset-md="3" offset-sm="0" justify="center" class="pa-0">

                <v-overlay :value="loading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <v-col v-if="logo" align="center">
                    <v-img :src="require(`@/assets/${logo}`)" width="100"></v-img>
                </v-col>

                <v-col v-if="reg && reg.processed != 1" md="12">
                    <v-card>
                        <v-card-title class="px-3">Card Details</v-card-title>
                        <v-divider></v-divider>
                            <div class="px-4 py-2 pb-2">
                                <v-row>
                                    <!-- Reference -->
                                    <v-col md="12" class="py-0">
                                        <v-text-field
                                            v-model="card.merchantTransactionId"
                                            label="Reference"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <!-- Address 1 -->
                                    <v-col md="12" class="py-0">
                                        <v-text-field
                                            v-model="card.address1"
                                            :rules="[rules.required]"
                                            label="1st Line Address"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <!-- Postcode -->
                                    <v-col md="12" class="py-0">
                                        <v-text-field
                                            v-model="card.postcode"
                                            label="Postcode"
                                            :rules="[rules.required]"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                      
                                <v-row>
                                    <v-col md="12" class="py-0">
                                    <form ref="paymentForm" v-if="host == 'localhost'" :action="url" class="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
                                    <form ref="paymentForm" v-else :action="url" class="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
                                    </v-col>
                                </v-row>
                              
                            </div>
                    </v-card>

                    <v-row v-if="result && result.result.code == '000.000.000'" class="mt-4">
                        <v-col md="12" class="py-0">
                            <v-alert
                                type="success"
                                text border="left"
                                dismissible
                                class="mb-2">
                                Code: {{ result.result.code }}<br>
                                Description: {{ result.result.description }}
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row v-else-if="result && result.result.code != '000.000.000'" class="px-4">
                        <v-col md="12" class="">
                            <v-alert type="error" text border="left" dismissible>
                                Code: {{ result.result.code }}<br>
                                Description: {{ result.result.description }}
                            </v-alert>
                        </v-col>
                    </v-row>

                    <!-- Footer - Harry Hall -->
                    <v-row class="text-caption px-5 mt-5 footer-text" v-if="reg.merchantUuid == '8acda4c970cebc530170d3d163e22569'">
                        As a valued member of the Harry Hall One Club, we regret to inform you that your recent payment has been declined by your card provider.
                        Please can you promptly bring your account up to date by using the “register” button below to update your card details.
                        If you prefer you can contact our customer services team on 01274 711011 and they will be happy to take your card details over the phone.
                    </v-row>
                </v-col>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';

export default {
    directives: { mask },
    data() {
        return {
            reg: null,
            card: {
                merchantTransactionId: null,
                address1: null,
                postcode: null
            },
            rules: {
                required: v => !!v || 'Required.',
            },
            result: null,
            loading: false,
            logo: null,
            url: window.location.href,
            path: null
        }
    },
    computed: {

    },
    beforeMount() {
        this.clicked();
        this.getRegistration();
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();
            if(this.$refs.form.validate()) {
                axios({
                method: 'post',
                url: 'register-card-live',
                data: { card: this.card,
                        entityId: this.reg.channelUuid,
                        client: { id: this.reg.clientId, merchantCustomerId: this.reg.merchantTransactionId},
                        userId: this.reg.createdBy,
                        rblId: this.reg.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response.data);
                    this.result = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        createCheckout() {
            axios({
            method: 'post',
            url: 'register-card-cnp-live',
            data: { entityId: this.reg.channelUuid,
                    client: { id: this.reg.clientId, merchantCustomerId: this.reg.merchantTransactionId},
                    userId: this.reg.createdBy,
                    card: this.card,
                    rblId: this.reg.id },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                var jq = document.createElement('script');
                jq.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js');
                document.head.appendChild(jq);

                const cnp = document.createElement('script');
                cnp.setAttribute('src', 'https://dally.totalprocessing.com/cnp-register.js');
                document.head.appendChild(cnp);
            
                const cnpScript = document.createElement('script');
                this.checkoutId = response.data.id;
                console.log(this.checkoutId);
                console.log(response.data);
                cnpScript.setAttribute('src', 'https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId='+this.checkoutId);
                document.head.appendChild(cnpScript);
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getRegStatus() {
            axios({
            method: 'post',
            url: `get-reg-status-live`,
            data: { path: this.path,
                    token: this.$route.params.id,
                    entityId: this.reg.channelUuid,
                    client: { id: this.reg.clientId, merchantCustomerId: this.reg.merchantTransactionId},
                    userId: this.reg.createdBy },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.result = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getRegistration() {
            axios({
                method: 'post',
                url: 'get-reg-by-link',
                data: { token: this.$route.params.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(this.reg);
                    this.card.merchantTransactionId = response.data[0].merchantTransactionId;
                    this.logo = response.data[0].logo;
                    this.reg = response.data[0];
                    this.card.address1 = response.data[0].street1;
                    this.card.postcode = response.data[0].postcode;
                    console.log(this.reg);

                    if(this.$route.query.resourcePath) {
                        console.log(this.$route.query.resourcePath);
                        this.path = (this.$route.query.resourcePath.replace('/v1/checkouts/', '')).replace('/payment', '');
                        this.getRegStatus();
                    }
                    else {
                        this.createCheckout();
                    } 
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        clicked() {
            axios({
                method: 'post',
                url: 'reg-by-link-clicked',
                data: { token: this.$route.params.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {

                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style scoped>
    #regBylink-container {
        margin-left: -55px;
    }

    .card-items {
        font-family: 'Courier New', Courier, monospace;
        font-weight: 600;
        fill: #fff;
    }

    #svg-visa {
        background: url('../assets/tp-card-blank-visa.png') no-repeat;
        background-position: center;
        background-size: 70%;
    }

    #svg-mastercard {
        background: url('../assets/tp-card-blank-mastercard.png') no-repeat;
        background-position: center;
        background-size: 70%;
    }
    
    #svg-blank {
        background: url('../assets/tp-card-blank.png') no-repeat;
        background-position: center;
        background-size: 70%;
    }

    .reg-form-svg {
        z-index: 10;
        position: relative;
    }

    .reg-form-col {
        z-index: 0;
        position: relative;
        margin-top: -25%;

    }

    .reg-form-card {
        padding-top: 25% !important;
    }

    .footer-text {
        font-size: 10px;;
    }
</style>